import { render, staticRenderFns } from "./payment-comp.vue?vue&type=template&id=ff368f76&scoped=true"
import script from "./payment-comp.vue?vue&type=script&lang=js"
export * from "./payment-comp.vue?vue&type=script&lang=js"
import style0 from "./payment-comp.vue?vue&type=style&index=0&id=ff368f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff368f76",
  null
  
)

export default component.exports